export default {
    BUBBLE_WAREHOUSES: 'bubble-warehouses',
    WAREHOUSE_FAMILIES: 'warehouse-families',
    BUBBLES: 'bubbles'
};
